import { Routes, Route, Navigate } from 'react-router-dom'
import { isLoggedIn } from './api'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import CasesPage from './pages/CasesPage'
import CaseEditPage from './pages/CaseEditPage'
import ReportsPage from './pages/ReportsPage'
import ReportEditPage from './pages/ReportEditPage'
import CategoriesPage from './pages/CategoriesPage'
import LeadsPage from './pages/LeadsPage'
import HomeConfigPage from './pages/HomeConfigPage'

function RequireAuth({ children }: { children: React.ReactNode }) {
  if (!isLoggedIn()) {
    return <Navigate to="/login" replace />
  }
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="cases" element={<CasesPage />} />
        <Route path="cases/new" element={<CaseEditPage />} />
        <Route path="cases/:id/edit" element={<CaseEditPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="reports/new" element={<ReportEditPage />} />
        <Route path="reports/:id/edit" element={<ReportEditPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="leads" element={<LeadsPage />} />
        <Route path="home-config" element={<HomeConfigPage />} />
      </Route>
    </Routes>
  )
}
